import {
  Button,
  Modal,
  Form,
  Input,
  Flex,
  Typography,
  message,
  Select,
  Table
} from "antd";
import React, {
  forwardRef,
  useState,
  useImperativeHandle,
  useEffect,
} from "react";
import { EditOutlined, BankOutlined } from "@ant-design/icons";
import commonFn from "@/utils/commonFn";
import http from "@/utils/http";
import api from "@/utils/api";
import CustomUploadNewBank from "@/hocComponents/customUploadNewBank";
const AddModal = forwardRef((props, ref) => {
  const [, setBankList] = useState([]);
  const [, setBankLoading] = useState(false);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [, setStatementFiles] = useState([]);
  const [, setPreviewIndex] = useState(-1);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [, setAllFilesState] = useState([]);
  const [filePaths, setFilePaths] = useState([]);
  const { onSuccess } = props;
  const [bankTableData, setBankTableData] = useState([]);
  const [ownerList, setOwnerList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const { amountToDollarBracketFn } = commonFn;
  const syncFileList = (files = []) => {
    setFilePaths(files);
  };

  const getOwnerIdList = async () => {
    const response = await http.get(api.getOwnerDictList);
    setOwnerList(response?.data || []);
  };

  useEffect(() => {
    setStatementFiles(filePaths);
    setAllFilesState(filePaths);
    setPreviewIndex(filePaths.length ? 0 : -1);
    form.setFieldsValue({
      fileList: filePaths,
      bankFile: filePaths,
    });
  }, [filePaths, form]);

  useImperativeHandle(ref, () => ({
    setModelAdd: async () => {
      form.resetFields();
      setStatementFiles([]);
      setAllFilesState([]);
      setPreviewIndex(-1);
      setFilePaths([]);
      setVisible(true);
       setBankTableData([]); 
      await loadCopyFromBank();
      await getOwnerIdList()
    },
  }));
  const loadCopyFromBank = async () => {
    setBankLoading(true);
    const res = await http.get(`${api.getBackDictList}`);
    setBankList(res.data || []);
    setBankLoading(false);
  };

  function useLazySelect(apiUrl, cacheKey, mapper, enableCache = true) {
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    const load = async (params = {}) => {
      if (options.length && enableCache) return;

      setLoading(true);
      let res;

      // 带参数
      if (params && Object.keys(params).length > 0) {
        res = await http.get(apiUrl, { params });
      } else {
        res = await http.get(apiUrl);
      }

      const raw = res?.data || [];

      setOptions(mapper(raw));
      setLoading(false);
    };

    return { options, loading, load };
  }
  const trustSelect = useLazySelect(api.getTrustDictList, "trust", (data) =>
    data.map((d) => ({
      label: d.trustNameTitle,
      value: d.trustId,
      glChartNameId: d.glChartNameId,
    })),
  );

  // const stateSelect = useLazySelect(api.getStateDictList, "state", (data) =>
  //   data.map((s) => ({ label: s, value: s })),
  // );
  const stateSelect = useLazySelect(api.getStateDictList, "state", (data) =>
  Object.entries(data || {}).map(([key, label]) => ({
    label,   
    value: key, 
  })),
);
  const glSelect = useLazySelect(
    api.getBankGLById,
    "glacct",
    (data) =>
      data.map((d) => ({
        label: d.glAcctTitle,
        // value: d.glChartId,
        value: d.glAcct,
      })),
    false,
  );
  const companySelect = useLazySelect(
    api.getCompanyDictList,
    "company",
    (data) =>
      data.map((d) => ({
        label: d.companyNameCode,
        value: d.companyId,
      })),
  );

  const onTrustChange = async (trustId) => {
    const trust = trustSelect.options.find((item) => item.value === trustId);
    if (!trust) return;
    const glId = Number(trust.glChartNameId);
    await fetchBankDataByTrustId(trustId);
    await glSelect.load({ glChartNameId: glId });
  };
  const fetchBankDataByTrustId = async (trustId) => {
  if (!trustId) {
    setBankTableData([]);
    return;
  }

  setTableLoading(true);
  try {
    const res = await http.get(api.getBankByTrust, { params: { trustId } });
    if (res?.code === "1" && res?.data) {
      // setBankTableData(res.data);
       const sorted = [...res.data].sort(
    (a, b) => (b.bankActive ?? 0) - (a.bankActive ?? 0)
  );
  setBankTableData(sorted);
    } else {
      setBankTableData([]);
    }
  } catch (error) {
    console.error("Failed to fetch bank data:", error);
    setBankTableData([]);
  } finally {
    setTableLoading(false);
  }
};


  const uploadByBankApi = async (file, fieldType) => {
    const formData = new FormData();
    formData.append("files", file.originFileObj);
    formData.append("type", fieldType);

    try {
      setUploadLoading(true);
      const res = await http.post(api.getBankUpload, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (res.code === "1") return res.data[0];
      throw new Error(res.msg || "Upload failed");
    } finally {
      setUploadLoading(false);
    }
  };

  const addOldFn = async (files) => {
    setBtnDisabled(true);
    try {
      const currentFile = files?.[files.length - 1];
      if (!currentFile?.originFileObj) {
        return { flag: false };
      }

      const uploadedFile = await uploadByBankApi(currentFile, "bankFile");
      const normalizedFile = {
        ...uploadedFile,
        // id: uploadedFile?.id || uploadedFile?.uuid || currentFile.uid,
        uid: uploadedFile?.customId || currentFile.uid,
        type: "bankStatement",
        name:
          uploadedFile?.fileDateName ||
          uploadedFile?.fileName ||
          currentFile.name,
        fileName:
          uploadedFile?.fileDateName ||
          uploadedFile?.fileName ||
          currentFile.name,
        allPath:
          uploadedFile?.url ||
          uploadedFile?.allPath ||
          (currentFile.originFileObj &&
            URL.createObjectURL(currentFile.originFileObj)),
        originFileObj: currentFile.originFileObj,
        size: currentFile.size,
      };

      return {
        flag: true,
        fileData: normalizedFile,
      };
    } catch (error) {
      console.error(error);
      message.error(error?.message || "Upload failed");
      return { flag: false };
    } finally {
      setBtnDisabled(false);
    }
  };
  const deleteOldFn = async (file) => {
    return true;
  };

  const deleteBase64FileFn = async (file) => {
    const list = filePaths.filter((item) =>
      file?.uuid ? item.uuid !== file.uuid : item.uid !== file.uid,
    );
    return list;
  };

  // 提交
  const onFinish = async () => {
    setLoading(true);
    try {
      const values = await form.validateFields();
      const fileList = form.getFieldValue("fileList") || [];
      const params = {
        ownerId: values?.ownerId || undefined,
        name: values?.name || undefined,
        street: values?.street || undefined,
        city: values?.city || undefined,
        state: values?.state || undefined,
        zip: values?.zip || undefined,
        phone: values?.phone || undefined,
        transitCp: values?.transitCp || undefined,
        cpAcct: values?.cpAcct || undefined,
        managementCompanyId: values?.managementCompanyId || undefined,
        trustId: values?.trustId || undefined,
        bank: values?.bank || undefined,
        remark: values?.remark || undefined,
        lastCheckNo: values?.lastCheckNo || undefined,
        glAcct: values?.glAcct || undefined,
        isNeedRec: values?.isNeedRec || undefined,
        positivePay: values?.positivePay || undefined,
        baiFile: values?.baiFile || undefined,
        balance: values?.balance || undefined,
        active: values?.active || undefined,
        fileList: fileList.map((item) => ({
          type: item?.type,
          path: item?.path,
          fileName: item?.fileName || item?.name,
          status: item?.status ?? 0,
        })),
      };
      const res = await http.post(api.getBankAdd, params);
      if (res?.code === "1") {
        message.success("Bank Created Successfully.");

        setVisible(false);
        form.resetFields();
        syncFileList([]);
        onSuccess && onSuccess();
      } else {
        message.error(res?.msg);
      }
    } catch (err) {
      console.error(err);
      message.error("Request failed, please try again");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={
        <Flex justify="flex-start" align="flex-start" className="model_title">
          <EditOutlined className="model_title_mr10" />
          <Typography.Title level={4} className="mg">
            CREATE BANK
          </Typography.Title>
        </Flex>
      }
      width="95%"
      open={visible}
      onCancel={() => {
        setVisible(false);
        form.resetFields();
        setStatementFiles([]);
        setAllFilesState([]);
        setPreviewIndex(-1);
        syncFileList([]);
      }}
      centered
      maskClosable={false}
      footer={
        <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
          <Button
            key="back"
            onClick={() => {
              setVisible(false);
              form.resetFields();
              setStatementFiles([]);
              setAllFilesState([]);
              setPreviewIndex(-1);
              syncFileList([]);
            }}
          >
            Cancel
          </Button>
          <Button
            key="submit"
            type="primary"
            loading={loading || uploadLoading}
            onClick={() => form.submit()}
          >
            Submit
          </Button>
        </div>
      }
    >
      <Flex justify="space-between" align="flex-start">
        <div className="model_top" style={{ width: "100%" }}>
          <div>
            <Form
              form={form}
              name="createBankForm"
              layout="horizontal"
              labelCol={{ style: { width: "200px" } }}
              wrapperCol={{ style: { flex: 1 } }}
              onFinish={onFinish}
            >
              <Flex align="flex-start" justify="space-between" gap={16}>
                {/* ========== 左侧：Bank Detail ========== */}
                <div style={{ flex: "0 0 26%" }}>
                  <div className="modal-section-title">
                    <BankOutlined /> Bank Detail
                  </div>
                  {/*Beneficiary  */}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                  <Form.Item label="Bank Account Owner" name="ownerId" style={{ marginBottom: 0 }}>
                    <Select
                      showSearch
                      allowClear
                      placeholder="Select a type"
                      optionFilterProp="label"
                      filterOption={(input, option) =>
                        (option?.titleName ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      fieldNames={{
                        label: 'titleName',
                        value: 'ownerId',
                      }}
                      options={ownerList}
                    />
                  </Form.Item>

                  <Form.Item
                    name="trustId"
                    label="Beneficiary/Entity"
                    rules={[{ required: true }]}
                       style={{ marginBottom: 0 }}
                  >
                    <Select
                     showSearch
                     optionFilterProp="label"
                      placeholder="Select Trust"
                      loading={trustSelect.loading}
                      options={trustSelect.options}
                      onDropdownVisibleChange={(open) =>
                        open && trustSelect.load()
                      }
                      onChange={onTrustChange}
                    />
                  </Form.Item>

                  <Form.Item
                      name="managementCompanyId"
                      label="Account Managing Company"
                      rules={[{ required: true }]}
                         style={{ marginBottom: 0 }}
                    >
                      <Select
                       showSearch
                      optionFilterProp="label"
                         placeholder="Select Company"
                        loading={companySelect.loading}
                        onDropdownVisibleChange={(open) =>
                          open && companySelect.load()
                        }
                        options={companySelect.options}
                      />
                    </Form.Item>

                  <Form.Item name="remark" label="Remark"    style={{ marginBottom: 0 }}>
                    <Input placeholder="Remark" />
                  </Form.Item>
              
                  <Form.Item
                    name="name"
                    label="Bank Name"
                    rules={[{ required: true }]}
                       style={{ marginBottom: 0 }}
                  >
                    <Input placeholder="Bank Name" />
                  </Form.Item>

                  <Form.Item name="street" label="Street"    style={{ marginBottom: 0 }}>
                    <Input placeholder="Street" />
                  </Form.Item>

                  <Form.Item name="city" label="City"    style={{ marginBottom: 0 }}>
                    <Input placeholder="City" />
                  </Form.Item>

                  <Form.Item
                    name="state"
                    label="State"
                    rules={[{ required: true }]}
                       style={{ marginBottom: 0 }}
                  >
                    <Select
                     showSearch
                     optionFilterProp="label"
                      placeholder="Select State"
                      loading={stateSelect.loading}
                      onDropdownVisibleChange={(open) =>
                        open && stateSelect.load()
                      }
                      options={stateSelect.options}
                    />
                  </Form.Item>

                  {/* <Form.Item
                    name="zip"
                    label="Zip"
                    rules={[{ required: true }]}
                  >
                    <Input placeholder="Zip" />
                  </Form.Item> */}

                  {/* <Form.Item
                    name="phone"
                    label="Phone"
                    rules={[{ required: true }]}
                  >
                    <Input placeholder="Phone" />
                  </Form.Item> */}
                  <Form.Item
                    name="zip"
                    label="Zip"
                    rules={[
                      { required: true, message: "Zip is required!" },
                      { validator: commonFn.zipValidator },
                    ]}
                       style={{ marginBottom: 0 }}
                  >
                    <Input placeholder="Zip" />
                  </Form.Item>
                  <Form.Item
                    name="phone"
                    label="Phone"
                    rules={[
                      { required: true, message: "Phone is required!" },
                      { validator: commonFn.usPhoneValidator },
                    ]}
                       style={{ marginBottom: 0 }}
                  >
                    <Input placeholder="Phone" />
                  </Form.Item>

                  <Form.Item
                    name="transitCp"
                    label="Routing"
                    rules={[{ required: true }]}
                       style={{ marginBottom: 0 }}
                  >
                    <Input placeholder="Routing" />
                  </Form.Item>

                  <Form.Item
                    name="cpAcct"
                    label="Account Number"
                    rules={[{ required: true }]}
                       style={{ marginBottom: 0 }}
                  >
                    <Input placeholder="Account#" />
                  </Form.Item>

                  {/* Last Check# */}
                  <Form.Item
                    name="lastCheckNo"
                    label="Starting Check #"
                    rules={[{ required: true }]}
                       style={{ marginBottom: 0 }}
                  >
                    <Input placeholder="1st Check #" />
                  </Form.Item>

                  {/* Bank # */}
                  <Form.Item
                    name="bank"
                    label="PPM Bank Number"
                    rules={[{ required: true }]}
                       style={{ marginBottom: 0 }}
                  >
                    <Input placeholder="Bank" />
                  </Form.Item>
                  <Form.Item
                    name="glAcct"
                    label="Cash GL"
                    rules={[{ required: true }]}
                       style={{ marginBottom: 0 }}
                  >
                    <Select
                     showSearch
                     optionFilterProp="label"
                      placeholder="Select GL"
                      loading={glSelect.loading}
                      options={glSelect.options}
                    />
                  </Form.Item>

                  <Form.Item
                    name="active"
                    label="Active"
                    rules={[{ required: true }]}
                       style={{ marginBottom: 0 }}
                  >
                    <Select
                      options={[
                        { value: "1", label: "Yes" },
                        { value: "0", label: "No" },
                      ]}
                    />
                  </Form.Item>
                  {/* Is Need Rec */}
                  <Form.Item
                    name="isNeedRec"
                    label="Need Bank Reconciliation?"
                    rules={[{ required: true }]}
                       style={{ marginBottom: 0 }}
                  >
                    <Select
                      options={[
                        { value: "1", label: "Yes" },
                        { value: "0", label: "No" },
                      ]}
                    />
                  </Form.Item>

                  <Form.Item
                    name="positivePay"
                    label="Positive Pay File"
                    rules={[{ required: true }]}
                       style={{ marginBottom: 0 }}
                  >
                    <Select
                      options={[
                        { value: "1", label: "Yes" },
                        { value: "0", label: "No" },
                      ]}
                    />
                  </Form.Item>
                  <Form.Item name="baiFile" label="Bai file"    style={{ marginBottom: 0 }}>
                    <Select
                      options={[
                        { value: "1", label: "Yes" },
                        { value: "0", label: "No" },
                      ]}
                    />
                  </Form.Item>
                </div>
                </div>
                <div style={{ flex: "0 0 35%" }}>
                  {/* upload */}
                  <div
                    style={{
                      marginBottom: "16px",
                      fontWeight: "bold",
                      fontSize: "20px",
                    }}
                  >
                    Upload PDF image
                  </div>
                  <Form.Item
                    labelCol={{ span: 0 }}
                    wrapperCol={{ span: 24 }}
                    label={null}
                  >
                    <div>
                      <div className="uploadText">
                        Uploaded files only support JPG, PNG or PDF.
                      </div>
                      <div
                        style={{ marginTop: "20px", display: "flex", gap: 16 }}
                      >
                        {/* Upload Bank File */}
                        <div style={{ flex: 1 }}>
                          <Form.Item name="bankFile" noStyle>
                            <CustomUploadNewBank
                              customConfig={{
                                uploadButtonStyle: {
                                  top: "0",
                                },
                                pdfHeight: "62vh",
                                fileFullName: "name",
                                notMultiple: true,
                                accept: ".jpg, .jpeg, .png, .pdf",
                                status: "add",
                                deleteOldFn: deleteOldFn,
                                deleteBase64FileFn: deleteBase64FileFn,
                                addOldFn: addOldFn,
                              }}
                              setFilePaths={syncFileList}
                              filePaths={filePaths}
                              setBtnDisabled={setBtnDisabled}
                              btnDisabled={btnDisabled}
                            />
                          </Form.Item>
                        </div>
                      </div>
                    </div>

                    <Form.Item name="fileList" hidden />
                  </Form.Item>
                </div>

<div style={{ flex: "0 0 38%", overflow: 'auto' }}>
  <div className="modal-section-title" style={{ marginBottom: "12px" }}>
    Bank Information
  </div>
  <Table
    rowClassName="table-row-gradient"
    dataSource={bankTableData}
    loading={tableLoading}
    size="small"
    pagination={false}
    scroll={{ x: true }}  
    rowKey="bankId"
    columns={[
      {
        title: "Company",
        dataIndex: "company",
        key: "company",
        ellipsis: true,
        render: (text) => text,
      },
      {
        title: "Bank Name",
        dataIndex: "bankName",
        key: "bankName",
        ellipsis: true,
        render: (text) => text ,
      },
      {
        title: "Account#",
        dataIndex: "accountNumber",
        key: "accountNumber",
        ellipsis: true,
        render: (text) => text ,
      },
      {
        title: "PPM Bank",
        dataIndex: "bank",
        key: "bank",
        render: (text) => text,
      },
      {
        title: "Cash GL",
        dataIndex: "cashGl",
        key: "cashGl",
        render: (text) => text ,
      },
      {
        title: "Remark",
        dataIndex: "remark",
        key: "remark",
        ellipsis: true,
        render: (text) => text ,
      },
      {
        title: "Balance",
        dataIndex: "balance",
        key: "balance",
        width: 80,
       render: (text) =>
       text === null || text === undefined || text === "" || Number(text) === 0
      ? "$0"
      : commonFn.amountToDollarBracketFn(text),
        // render: (text) => commonFn.amountToDollarBracketFn(text),
      },
      {
        title: "Bank Active",
        dataIndex: "bankActive",
        key: "bankActive",
        width: 100,
        render: (text) => text === 1 ? 'Active' : "Inactive" ,
      },
    ]}
    locale={{
      emptyText: tableLoading ? "Loading..." : "No data available",
    }}
    style={{ width: "100%" }}
  />
</div>

              </Flex>
            </Form>
          </div>
        </div>
      </Flex>
    </Modal>
  );
});

export default AddModal;
